module.exports = __webpack_public_path__ + "static/img/4-4.6aab344a.png";